import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
const CASINO_GAMES_ONLINE_PLAYERS_FEATURE_KEY = "casinoGamesOnlinePlayers";
const initialCasinoGamesOnlinePlayers = {
  map: {},
  loaded: false
};
const getMap = (list, prevMap) => {
  const res = prevMap ? JSON.parse(JSON.stringify(prevMap)) : {};
  for (let i = 0; i < (list == null ? void 0 : list.length); i++) {
    const el = list == null ? void 0 : list[i];
    if ((el == null ? void 0 : el.count) === 0) {
      delete res[el == null ? void 0 : el.id];
    } else {
      res[el == null ? void 0 : el.id] = el.count;
    }
  }
  return res;
};
const casinoGamesOnlinePlayersSlice = createSlice({
  name: CASINO_GAMES_ONLINE_PLAYERS_FEATURE_KEY,
  initialState: initialCasinoGamesOnlinePlayers,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getOnlinePlayersStart: (state, _action) => {
      state.loaded = false;
    },
    getOnlinePlayersSuccess: (state, action) => {
      state.loaded = true;
      state.map = getMap(action.payload);
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getOnlinePlayersFail: (state, _action) => {
      state.loaded = false;
    },
    onlinePlayersSocketSuccess: (state, action) => {
      var _a;
      state.map = getMap((_a = action.payload) == null ? void 0 : _a.payload, state.map);
    }
  }
});
const casinoGamesOnlinePlayersReducer = casinoGamesOnlinePlayersSlice.reducer;
const {
  getOnlinePlayersStart,
  getOnlinePlayersSuccess,
  getOnlinePlayersFail,
  onlinePlayersSocketSuccess
} = casinoGamesOnlinePlayersSlice.actions;
const getCasinoGamesOnlinePlayersState = (rootState) => rootState[CASINO_GAMES_ONLINE_PLAYERS_FEATURE_KEY];
const selectCasinoGamesOnlinePlayersByGameId = createSelector(
  getCasinoGamesOnlinePlayersState,
  (_, gameId) => gameId,
  (s, gameId) => {
    var _a;
    return (_a = s.map) == null ? void 0 : _a[gameId];
  }
);
const selectCasinoGamesOnlinePlayersLoaded = createSelector(
  getCasinoGamesOnlinePlayersState,
  (s) => s.loaded
);
const fetchOnlinePlayersEpic = (action$, _state$, { Api }) => action$.pipe(
  ofType(getOnlinePlayersStart.type),
  switchMap((action) => {
    return Api.casinoSession.getOnlinePlayers(action.payload).pipe(
      map((res) => getOnlinePlayersSuccess(res)),
      catchError((err) => of(getOnlinePlayersFail(err)))
    );
  })
);
const fetchOnlinePlayers = (payload) => ({
  type: getOnlinePlayersStart.type,
  payload
});
export {
  CASINO_GAMES_ONLINE_PLAYERS_FEATURE_KEY,
  casinoGamesOnlinePlayersReducer,
  casinoGamesOnlinePlayersSlice,
  fetchOnlinePlayers,
  fetchOnlinePlayersEpic,
  getCasinoGamesOnlinePlayersState,
  getOnlinePlayersFail,
  getOnlinePlayersStart,
  getOnlinePlayersSuccess,
  initialCasinoGamesOnlinePlayers,
  onlinePlayersSocketSuccess,
  selectCasinoGamesOnlinePlayersByGameId,
  selectCasinoGamesOnlinePlayersLoaded
};
